import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0A74D3",
        secondary: "#FFFFFF",
        accent: "#0A74D3",
        error: "#cf201d"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  }
});
